import script from "./VisionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./VisionSection.vue?vue&type=script&setup=true&lang=js"

import "./VisionSection.vue?vue&type=style&index=0&id=21c14e22&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c14e22"]])

export default __exports__